import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getBraintreeClientToken(token) {
  const url = 'api/braintree/token/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeou: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}
// don't forget trailing slashes!
function createBraintreeCustomer(token, id) {
  const url = 'api/user/braintree/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      id,
    },
  });
}

function getBraintreeCustomer(token, userId) {
  const url = 'api/user/braintree/' + userId + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createBraintreePaymentMethod(token, userId, nonce, defaultSource) {
  const url = 'api/braintree/payment_methods/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      nonce,
      make_default: defaultSource,
      id: userId,
    },
  });
}

function deleteBraintreePaymentMethod(token, paymentMethod) {
  const url = 'api/braintree/payment_methods/' + paymentMethod + '/';
  return axios({
    method: 'delete',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function updateBraintreePaymentMethod(token, paymentMethod, defaultSource) {
  const url = 'api/braintree/payment_methods/' + paymentMethod + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      make_default: defaultSource,
    },
  });
}

function getBraintreeCharges(token, userId) {
  const url = 'api/braintree/charges/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    params: {
      id: userId,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getBraintreePlans(userId) {
  const url = 'api/braintree/plans/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      id: userId,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createMembership(
  token,
  userId,
  braintreePlanId,
  braintreePlan,
  firstCharge,
  paymentMethodToken,
  discount,
) {
  const url = 'api/braintree/membership/' + userId + '/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      braintree_plan_id: braintreePlanId,
      braintree_plan: braintreePlan,
      first_charge: firstCharge,
      payment_method_token: paymentMethodToken,
      discount,
    },
  });
}

function updateSubscription(
  token,
  userId,
  subscriptionId,
  paymentMethodToken,
) {
  const url = 'api/braintree/subscription/' + userId + '/';
  console.log(paymentMethodToken);
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      subscription_id: subscriptionId,
      payment_method_token: paymentMethodToken,
    },
  });
}

function applyMembershipDiscountCode(code, braintreeMembershipCode) {
  const url = `api/membership_discount/?code=${code}&braintree_membership_code=${braintreeMembershipCode}`;
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

export {
  getBraintreeClientToken,
  createBraintreeCustomer,
  getBraintreeCustomer,
  createBraintreePaymentMethod,
  deleteBraintreePaymentMethod,
  updateBraintreePaymentMethod,
  getBraintreeCharges,
  getBraintreePlans,
  createMembership,
  updateSubscription,
  applyMembershipDiscountCode,
};
